import { useExperiences } from "@/services/hooks";
import { Box, Typography } from "@mui/material";
import ExperienceCard from "@/components/ExperienceCard";
import NoteActions from "@/components/NoteActions";

export default function ExperiencesContainer({ artistKey }) {
  const { data: artistContent } = useExperiences(artistKey);

  if (artistContent?.length == 0) {
    return null;
  }

  return (
    <Box sx={{ px: 2 }}>
      <Typography variant="h6" sx={{ mt: 4, fontWeight: 800 }}>
        Experiences
      </Typography>
      {artistContent?.length == 0 && (
        <Typography variant="body1" color="darkgray" sx={{ my: 2 }}>
          New experiences coming soon.
        </Typography>
      )}

      {artistContent?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            overflowX: "scroll",
            scrollbarWidth: "none" /* Firefox */,
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {artistContent?.map((content, index) => (
            <Box key={index} sx={{ mr: 2 }}>
              <ExperienceCard content={content} />
              <NoteActions content={content} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
